import React, { Component } from 'react';
import IconInput from '../../components/icon-input';
import { Link, withRouter } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import './styles.css'

// if user forgets password, they can reset password on this page
class Forgotpassword extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async forgotPasswordHandler() {
    event.preventDefault();
    const { email } = this.state;
    if (!email) {
      alert('Missing Fields: Please Fill Out All Missing Fields');
      return;
    }
    // AWS Cognito integration here
    try {
      await Auth.forgotPassword(this.state.email);
      // go to forgotpwdverify page
      this.props.history.push('/forgotpwdverify');
    } catch (error) {
      console.log(error);
    }
  } // forgotPasswordHandler 

  render() {
    return (
      <div className="d-flex h-100 justify-content-center background-image">
        <div className="align-self-md-center h-auto w-40 p-4 form-container ">
          <p className="login-title">FORGOT YOUR PASSWORD?</p>
          <p style={{ 'color': 'white' }}>Please enter the email address associated with your account and we will
            email you a password reset verification code.</p>
          <IconInput icon='fa fa-envelope' placeholder='EMAIL' type='text' value={this.state.email} onChange={(input) => this.setState({ email: input.toLowerCase() })} />

          <button
            type='button'
            className='btn btn-info btn-block font-weight-bold'
            onClick={() => this.forgotPasswordHandler()}
          >
            SEND CODE
          </button>
          <Link
            to="/login"
            className=" btn btn-link btn-block font-weight-bold link"
          >
            CLICK HERE TO GO BACK TO LOGIN PAGE
          </Link>
        </div>
      </div>
    );
  }
}

export default withRouter(Forgotpassword);



// WEBPACK FOOTER //
// ./src/routes/forgotpassword/index.js